module.exports = __webpack_public_path__ + "static/awards-icon-9-29b114d9795b26d97b8ca29cf252154c.png";